// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"47":"2b06f694","350":"977083c2","353":"54810c53","561":"06deb028","667":"131d0383","825":"14faccee","916":"dc0939ed","946":"671dafd1"}[chunkId] + ".css";
};